import {SharedService} from '../services/shared-service';
import {PagedRequestDTO} from '../models/PagedRequestDTO';
import {PagedFilterDTO} from '../models/PagedFilterDTO';
import {DateUtil} from '../util/DateUtil';
import {TableControl} from '../models/TableControl';
import {EntityTable} from '../types/entity-table.enum';

export class RequestBuilderFunctions {

  public static getTblActivityPagedRequestDTO(tableControl: TableControl, policyId: string): PagedRequestDTO {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblActivity;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = tableControl.sortDirection;

    // Important Note:
    // - policyId & created are dynamic value fields

    const encounterByEncounterIdPagedFilterDTO = new PagedFilterDTO();
    encounterByEncounterIdPagedFilterDTO.name = 'encounterByEncounterId.transactionByTransactionId.policyId';
    encounterByEncounterIdPagedFilterDTO.value = policyId;

    const adjudicationStatusIdPagedFilterDTO = new PagedFilterDTO();
    adjudicationStatusIdPagedFilterDTO.name = 'adjudicationStatusId';
    adjudicationStatusIdPagedFilterDTO.value = '3';

    const benefitAmountProductCurrencyPagedFilterDTO = new PagedFilterDTO();
    benefitAmountProductCurrencyPagedFilterDTO.name = 'benefitAmountProductCurrency';
    benefitAmountProductCurrencyPagedFilterDTO.operator = '>=';
    benefitAmountProductCurrencyPagedFilterDTO.value = '0';

    const processingStatusId1PagedFilterDTO = new PagedFilterDTO();
    processingStatusId1PagedFilterDTO.name = 'processingStatusId_1';
    processingStatusId1PagedFilterDTO.operator = '>=';
    processingStatusId1PagedFilterDTO.value = '8';

    const processingStatusId2PagedFilterDTO = new PagedFilterDTO();
    processingStatusId2PagedFilterDTO.name = 'processingStatusId_2';
    processingStatusId2PagedFilterDTO.operator = '<=';
    processingStatusId2PagedFilterDTO.value = '11';

    const createdPagedFilterDTO = new PagedFilterDTO();
    createdPagedFilterDTO.name = 'created';
    createdPagedFilterDTO.operator = '>=';

    // Get "First" day of the current year:
    const date = new Date(new Date().getFullYear(), 0, 1);
    createdPagedFilterDTO.value = SharedService.formatDate(date, DateUtil.dateFormatWithoutSlashes);

    const pagedFilterTransactionType = new PagedFilterDTO();
    pagedFilterTransactionType.name = 'transactionTypeId';
    pagedFilterTransactionType.value = '2';

    // Final FieldMap to TableControl FieldMap
    pagedRequestDTO.fieldMap = {};
    pagedRequestDTO.fieldMap[`encounterByEncounterId`] = encounterByEncounterIdPagedFilterDTO;
    pagedRequestDTO.fieldMap[`adjudicationStatusId`] = adjudicationStatusIdPagedFilterDTO;
    pagedRequestDTO.fieldMap[`benefitAmountProductCurrency`] = benefitAmountProductCurrencyPagedFilterDTO;
    pagedRequestDTO.fieldMap[`processingStatusId_1`] = processingStatusId1PagedFilterDTO;
    pagedRequestDTO.fieldMap[`processingStatusId_2`] = processingStatusId2PagedFilterDTO;
    pagedRequestDTO.fieldMap[`created`] = createdPagedFilterDTO;

    return pagedRequestDTO;
  }

  public static getTableControls(length = 100,
                                 pageSize = 10,
                                 pageNumber = 0,
                                 pageSizeOptions = [5, 10, 25, 100]) {
    return {
      length,
      pageSize,
      pageNumber,
      pageSizeOptions
    };
  }
}
